import React from 'react';
import { motion } from 'framer-motion';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
// 1 Lanoma Court, Wheelers Hill, VIC, Australia
const PROPERTY_COORDS: [number, number] = [-37.920184, 145.178014];
// Solid terracotta dot for the property — minimal, editorial
const propertyIcon = L.divIcon({
  className: 'property-pin',
  html: `
    <div style="position: relative; width: 14px; height: 14px;">
      <div style="position: absolute; inset: -6px; border-radius: 50%; background: rgba(184, 92, 58, 0.15); animation: property-ping 3s cubic-bezier(0, 0, 0.2, 1) infinite;"></div>
      <div style="position: absolute; inset: 0; border-radius: 50%; background: #B85C3A; border: 1.5px solid #F5EFE4;"></div>
    </div>
  `,
  iconSize: [14, 14],
  iconAnchor: [7, 7]
});
export function PropertyMap() {
  return <section id="location" className="w-full bg-cream py-20 md:py-28 px-6" data-id="element-55">
      <div className="max-w-5xl mx-auto" data-id="element-56">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="text-center mb-10 md:mb-14" data-id="element-57">
          <h2 className="font-display text-3xl md:text-4xl tracking-wide text-charcoal leading-tight" data-id="element-58">
            A Quiet Court in Wheelers Hill
          </h2>
          <div className="w-8 h-[1px] bg-charcoal/20 mx-auto mt-5" data-id="element-59" />
        </motion.div>

        {/* Map frame */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="relative bg-cream border border-charcoal/10 overflow-hidden" data-id="element-60">
          {/* Address strip */}
          <div className="flex items-center justify-between gap-3 px-5 md:px-6 py-3.5 border-b border-charcoal/10 bg-cream" data-id="element-61">
            <span className="font-serif italic text-charcoal text-sm md:text-base truncate min-w-0" data-id="element-62">
              1 Lanoma Court, Wheelers Hill
            </span>
            <span className="text-[9px] md:text-[10px] uppercase tracking-[0.25em] text-ink-soft shrink-0" data-id="element-63">
              VIC 3150
            </span>
          </div>

          {/* Map */}
          <div className="h-[360px] md:h-[480px] w-full relative" data-id="element-64">
            <MapContainer center={PROPERTY_COORDS} zoom={15} scrollWheelZoom={false} className="w-full h-full" zoomControl={true} attributionControl={false} data-id="element-65">
              <TileLayer url="https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png" data-id="element-66" />
              <TileLayer url="https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png" opacity={0.7} data-id="element-67" />
              <Marker position={PROPERTY_COORDS} icon={propertyIcon} data-id="element-68" />
            </MapContainer>

            {/* Subtle brand wash */}
            <div className="brand-map-wash" data-id="element-69" />

            {/* Custom attribution */}
            <div className="absolute bottom-0 right-0 z-[401] px-3 py-1.5 bg-cream/90 text-[9px] tracking-wide text-ink-soft border-l border-t border-charcoal/10" data-id="element-70">
              ©{' '}
              <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer" className="hover:text-charcoal transition-colors" data-id="element-71">
                OpenStreetMap
              </a>{' '}
              ·{' '}
              <a href="https://carto.com/attributions" target="_blank" rel="noopener noreferrer" className="hover:text-charcoal transition-colors" data-id="element-72">
                CARTO
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}